import { Grid } from '@material-ui/core';
import * as React from 'react';
import { Space } from 'v2/components/Shared/Space';
import useBoolean from 'v2/hooks/useBoolean';

import { useStyles } from './styles';
import { FileInput } from '../FileInput';
import { Layout } from '../Layout';
import { Modal } from '../Modal';

function BankReceipt() {
  const classes = useStyles();
  const [isModalOpen, setModalState] = useBoolean(false);

  return (
    <Layout
      title='Comprovante bancário'
      description='Precisamos que você nos envie uma foto com o número da sua agência e conta, pode ser uma foto do seu cartão ou print do app do seu banco'
    >
      <Grid className={classes.content} container spacing={2}>
        <Grid item xs={12} sm={10}>
          <FileInput
            name='bank_receipt_image'
            label='Enviar comprovante*'
            validFormats='image/jpeg, image/png, image/jpg, application/pdf'
            helperText={
              <>
                <span id='bank-receipt-image-example-btn' className={classes.openModalBtn} role='button' onClick={setModalState.toTrue}>
                  Exemplos de comprovantes: <strong>Ver exemplo</strong>
                </span>
                <Space axis='vertical' size={8} />
                <span className={classes.helperText}>O arquivo deve ter no máximo 2MB e estar no formato .jpg, .jpeg, .png ou .pdf</span>
              </>
            }
          />
        </Grid>
      </Grid>
      <Modal isOpen={isModalOpen} handleClose={setModalState.toFalse}>
        <div className={classes.modalContent}>
          <p>Print contendo os dados bancários - exemplo</p>
          <img src='/img/bank-receipts.jpg' alt='Comprovantes bancários - exemplo' />
        </div>
      </Modal>
    </Layout>
  );
}

export { BankReceipt };
